/**
 * @fileoverview ConnectionUtil util
 */
'use strict';
// Library Import
import _ from 'lodash';
// Config Import
import AppConfig from '../AppConfig';
// Connection Import
import HTTP from '../connection/HTTP';
// Util Import
import * as ConstUtil from './ConstUtil';
import * as LogUtil from './LogUtil';

/**
 * ConnectionUtil
 *
 * @class ConnectionUtil
 */
class ConnectionUtil {
  constructor() {
    LogUtil.d(this.constructor.name + 'Class constructor call');
  }

  /**
   * 接続先選択
   *
   * @param {*} url APIのURL
   * @param {*} timeout タイムアウト時間
   * @memberof ConnectionUtil
   */
  selectConnection(url, timeout) {
    // リクエストヘッダー作成
    let headers = {};
    // トークン取得
    let token = localStorage.getItem(ConstUtil.Common.STORAGE_KEY.TOKEN);
    // ログイン後
    if (!_.isEmpty(token)) {
      headers = {
        [ConstUtil.Common.REQUEST_HEADER_KEYS.X_LOGIPULL_TOKEN]: token
      };
    }
    // デバックの場合
    if (AppConfig.isDebug) {
      // HTTPインスタンス生成
      HTTP.createInstance(
        AppConfig.accessPoint + AppConfig.apiPortNumber,
        headers,
        timeout
      );
      return;
    }
    // センター側APIの場合
    if (url.indexOf('/center') !== -1) {
      // HTTPインスタンス生成
      HTTP.createInstance(
        AppConfig.httpScheme +
          localStorage.getItem(ConstUtil.Common.STORAGE_KEY.CENTER_DOMAIN) +
          AppConfig.apiPortNumber,
        headers,
        timeout
      );
      return;
    }
    // HTTPインスタンス生成
    HTTP.createInstance(
      AppConfig.accessPoint + AppConfig.apiPortNumber,
      headers,
      timeout
    );
  }

  /**
   * API呼び出し
   *
   * @param {String} url APIのURL
   * @param {Object} request リクエストデータ
   * @param {Number} timeout タイムアウト時間
   * @param {Function} callback 呼び出し元のコールバック処理
   * @param {Boolean} isGetMethod GETメソッドフラグ
   * @memberof ConnectionUtil
   */
  callAPI(url, request, timeout, callback, isGetMethod) {
    // 接続先選択
    this.selectConnection(url, timeout);

    // GETの場合
    if (isGetMethod) {
      HTTP.get(url, request.data, function(err, res) {
        if (err) {
          // 異常時
          callback(err, null);
          return;
        }
        // 正常時
        callback(null, res);
        return;
      });
      return;
    }

    // 通信処理
    HTTP.post(url, request.data, function(err, res) {
      if (err) {
        // 異常時
        callback(err, null);
        return;
      }
      // 正常時
      callback(null, res);
      return;
    });
  }

  /**
   * アップロード
   *
   * @param {String} url アップロードURL
   * @param {Object} request リクエストデータ
   * @param {Object} axiosConfig axiosのconfig設定
   * @param {Function} callback 呼び出し元のコールバック処理
   * @memberof ConnectionUtil
   */
  upload(url, request, axiosConfig, callback) {
    // 通信処理
    HTTP.put(url, request.data, axiosConfig, function(err, res) {
      if (err) {
        // 異常時
        callback(err, null);
        return;
      }
      // 正常時
      callback(null, res);
      return;
    });
  }
}
export default new ConnectionUtil();



// WEBPACK FOOTER //
// ./src/js/util/ConnectionUtil.jsx